import { Box, CardMedia, Stack } from "@mui/material";

export default function ForgetPasswordIcon() {
  return (
    <Box sx={{ width: "60px", height: "60px" }}>
      <CardMedia component="img" image={`/icons/ForgetPasswordIcon.svg`} />
    </Box>
  );
}
